import { useMutation } from '@tanstack/react-query'
import { App } from 'antd'
import type { ContractDocumentStatus } from '@super-mega/server/contracts/contract'
import type { OrderContractBatchSetStatusInput } from '@super-mega/server/contracts/order'
import { useTRPC } from '@/trpc/react.ts'
import { getErrorMessage } from '@/utils/error.ts'
import { ContractStatusModal } from './contract-status-modal.tsx'
import { useContractDocumentInvalidation } from './hooks/use-contract-document-invalidation.ts'

export type OrderContractStatusEditing =
  | Omit<Extract<OrderContractBatchSetStatusInput, { orderType: 'rental' }>, 'status'>
  | Omit<Extract<OrderContractBatchSetStatusInput, { orderType: 'service' }>, 'status'>

export function OrderContractStatusModal({
  editing,
  onClose
}: {
  editing: OrderContractStatusEditing
  onClose: () => void
}) {
  const trpc = useTRPC()
  const { message } = App.useApp()
  const invalidate = useContractDocumentInvalidation()
  const mutation = useMutation(trpc.order.contracts.batchSetStatus.mutationOptions())
  const target = editing.target
  const count = target.mode === 'ids' ? target.ids.length : target.expectedCount
  const save = async (status: ContractDocumentStatus) => {
    try {
      const result = await mutation.mutateAsync({ ...editing, status })
      void message.success(
        `已处理 ${result.orderCount} 个订单的 ${result.total} 份合同：修改 ${result.updatedCount} 份，状态相同 ${result.unchangedCount} 份`
      )
      await invalidate()
      onClose()
    } catch (error) {
      void message.error(getErrorMessage(error, '修改订单合同状态失败'))
    }
  }
  return (
    <ContractStatusModal
      label={`将修改${target.mode === 'search' ? '当前搜索条件下全部' : '已选'} ${count} 个${editing.orderType === 'rental' ? '租赁' : '服务'}订单中的全部合同文件，包含已作废合同${target.mode === 'search' ? '及其他分页的订单' : ''}。`}
      pending={mutation.isPending}
      onSubmit={save}
      onClose={onClose}
    />
  )
}
